(function() {
    angular.module('GorillaBoy.services')
    .factory('UserService', [
        '$routeParams',
        '$http',
        '$log',
        '$q',
        '$rootScope',
        'SessionManager',
        'EndpointService',
        'AppConstants',
        UserService
    ]);

    function UserService($routeParams, $http, $log, $q, $rootScope, SessionManager, EndpointService, AppConstants) {
        // AppConstant bindings
        var httpMethods = AppConstants.HttpMethods;

        var userService = {},
        userPref = null;

        var CLIENT_PASSWORD_URL_SUFFIX = '/passwordurl';

        var isUnsignedInteger = function(input) {
            return parseInt(input) >= 0;
        };

        var serviceRoot = function(isNewAPI) {
            return isNewAPI ? EndpointService.endpoint(true) + 'users/' : EndpointService.endpoint() + 'user/';
        };

        userService.getUser = function() {
            var config = {
                url: serviceRoot(),
                method: httpMethods.GET
            };
            return $http(EndpointService.tokenize(config));
        };

        userService.getUserById = function(userId) {
            var config = {
                url: serviceRoot() + encodeURIComponent(userId),
                method: httpMethods.GET
            };
            return $http(EndpointService.tokenize(config));
        };

        userService.getUserGroups = function(userId) {
            var config = {
                url: serviceRoot() + encodeURIComponent(userId) + '/groups',
                method: httpMethods.GET
            };
            return $http(EndpointService.tokenize(config));
        };

        userService.searchUsers = function(params) {
            var config = {
                url: serviceRoot() + 'search',
                method: httpMethods.GET,
                params: params
            };
            return $http(EndpointService.tokenize(config));
        };

        userService.updateUser = function(userId, userData) {
            var config = {
                url: serviceRoot() + encodeURIComponent(userId),
                method: httpMethods.PUT,
                data: userData
            };
            return $http(EndpointService.tokenize(config));
        };

        userService.updateProfilePhoto = function(userId) {
            var config = {
                url: serviceRoot() + encodeURIComponent(userId),
                method: httpMethods.PUT
            };
            return $http(EndpointService.tokenize(config));
        };

        userService.getChangePasswordUrl = function() {
            var config = {
                url: EndpointService.endpoint() + 'client/' +
                    encodeURIComponent(EndpointService.clientId()) +
                    CLIENT_PASSWORD_URL_SUFFIX,
                method: httpMethods.GET
            };

            return $http(EndpointService.tokenize(config));
        };

        userService.changePreferences = function(userId, preferences) {
            var data = {
                WebPreferences: preferences
            };
            return userService.updateUser(userId, data);
        };

        userService.createUser = function(userData) {
            var config = {
                url: serviceRoot(),
                method: httpMethods.POST,
                data: userData
            };
            return $http(EndpointService.tokenize(config));
        };

        userService.setUserStatus = function(userId, activated) {
            var data = {};
            if (activated) {
                data.Activate = true;
            } else {
                data.Deactivate = true;
            }
            return userService.updateUser(userId, data);
        };

        userService.transferUserResources = function(userId, transfereeId, destinationFolderName) {
            var data = {
                OwnerId: transfereeId,
                // Service requires destinationFolderName to satisfy [\\u0020-\\u202D\\u202F-\\uFFFF]+ . Ref: https://code.amazon.com/packages/AWSGorillaBoyServiceModel/blobs/84cd5254aa11378d2b4d7a1447f59f5dea9df839/--/model/release/common/path-model.xml#L55
                DestinationFolderName: destinationFolderName.replace(/[\u0000-\u001F\u202E]/g, " ")
            };
            var config = {
                url: serviceRoot() + encodeURIComponent(userId) + '/resource',
                method: httpMethods.PUT,
                data: data
            };

            return $http(EndpointService.tokenize(config));
        };

        userService.deleteUser = function(userId) {
            var config = {
                url: serviceRoot() + encodeURIComponent(userId),
                method: httpMethods.DELETE
            };
            return $http(EndpointService.tokenize(config));
        };

        // @ng-doc UserService.isValidStorage()
        // currently we only check if the storage quota, when set, is valid.
        // we should extend the validation to check all other properties as well.
        userService.isValidStorage = function(quotaInBytes) {
            return isUnsignedInteger(quotaInBytes);
        };

        userService.getUserPreferences = function(userId) {
            var deferred = $q.defer(),
                req;

            if (userPref) {
                deferred.resolve(userPref);
            } else {
                req = {
                    url: serviceRoot() + encodeURIComponent(userId) + '/preferences',
                    method: httpMethods.GET
                };

                $http(EndpointService.tokenize(req)).then(
                    function(result) {
                        userPref = result.data;
                        deferred.resolve(userPref);
                    },
                    function(result) {
                        deferred.reject(result);
                    });
            }
            return deferred.promise;
        };

        userService.updateUserPreferences = function(userId, userPreferences) {
            var config = {
                url: serviceRoot() + encodeURIComponent(userId) + '/preferences',
                method: httpMethods.PATCH,
                data: {
                    UserPreferences: userPreferences
                }
            };
            return $http(EndpointService.tokenize(config));
        };

        userService.getUserResourcePreferences = function(resourceId){

             var config = {
                url: EndpointService.endpoint(true) + 'preferences',
                method: httpMethods.GET,
                params: {
                    resourceId: resourceId
                }
            };

            return $http(EndpointService.tokenize(config));
        };

         userService.updateUserResourcePreferences = function(resourceId, userResourcePreferences) {

            var config = {
                url: EndpointService.endpoint(true) + 'preferences',
                method: httpMethods.PATCH,
                params: {
                    resourceId: resourceId
                },
                data: {
                    UserResourcePreferences: userResourcePreferences
                }
            };

            return $http(EndpointService.tokenize(config));
        };

        return userService;
    }
}());
